import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Sora;

  opacity: ${({ active }) => (active ? '1' : '0')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  transition: all 0.5s ease;
`;

export const Comments = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  margin-left: 0.8rem;

  .ReactCollapse--collapse {
    transition: height 500ms;
    margin-bottom: 0.5rem;
  }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  height: 2rem;

  align-items: center;
  justify-content: space-between;

  cursor: pointer;

  span {
    font-weight: 600;
    font-size: 0.64710625rem;
    line-height: 0.8125rem;
  }

  svg {
    transform: ${({ open }) => (open ? 'rotate(90deg)' : 'rotate(-90deg)')};
    transition: transform 500ms ease;
    margin-right: 0.4rem;
  }
`;
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 25rem;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 0.25rem;
  }

  ::-webkit-scrollbar-track {
    background: #eff1f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a9aeb4;
    border-radius: 8px;
    border: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;

  margin-bottom: 0.8rem;
`;
export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 2rem;
`;
export const Avatar = styled.img`
  max-width: 1.765rem;
  max-height: 1.765rem;
  background: lightblue;
  border-radius: 50%;
`;
export const Comment = styled.div`
  width: 10.883125rem;
  margin-left: 0.588125rem;
`;
export const HeadTitle = styled.div`
  width: 100%;
  font-size: 0.646875rem;
  color: #7e858f;
  overflow-x: hidden;
  text-overflow: ellipsis;
  line-height: 0.815625rem;
  margin-bottom: 0.529375rem;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const Content = styled.p`
  color: #212326;
  font-size: 0.70625rem;
  line-height: 0.889375rem;
  word-wrap: break-word;
`;
